import { Plugin } from 'ckeditor5';
import { PlaceholderSchema } from './schema';
import { PlaceholderStore } from './store';
/**
 * This plugin adds support for rendering placeholders in the editor.
 */
export class Placeholders extends Plugin {
    static get pluginName() {
        return 'Placeholders';
    }
    static get requires() {
        return [PlaceholderStore, PlaceholderSchema];
    }
}
